import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import SpreadingLoveBoxes from "./HomePage/SpreadingLoveBoxes";
import TeachingMethodology from "./HomePage/TeachingMethodology";
import InteractiveGallery from "./HomePage/InteractiveGallery";
import ColContainer from "./HomePage/ColContainer";
import HomeTestimonialSlider from "./HomePage/HomeTestimonialSlider";
// import ThirdSection from "./HomePage/ThirdSection";
import ThirdSection from "./Admissions/ThirdSection";
import SpreadingLoveSection from "./HomePage/SpreadingLoveSection";
import HomeBlogs from "./HomePage/HomeBlogs";
import CustomButton from "./custom/CustomButton";
import HeartAnimation from "./custom/HeartAnimation";
import { homePageImages } from "../utils/constants";
import { Helmet } from "react-helmet";

export default function HomePage() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 20);
  }, []);
  const { ref, inView } = useInView({
    triggerOnce: true, // Trigger only once
    threshold: 0.5, // Visible when 50% of the element is in the viewport
  });

  return (
    <div>
      <Helmet>
        <title>Best Play School Mother's Pride | Delhi, India</title>
        <meta
          name="description"
          content="Mother's Pride, Delhi’s leading play school, nurturing young minds with love, learning, and laughter. Enroll your child in the best start to their future."
        />
        <meta
          name="keywords"
          content="best play school near me, top play schools in Delhi, best preschool in India, best preschool in Delhi, preschool in Delhi NCR, play school in Delhi NCR, nursery school in Delhi, nursery school in Gurgaon, play school near me, playschool, play group, pre nursery school, pre school admission, preschool Gurgaon, preschool Noida, preschool Indirapuram, preschool Ghaziabad, preschool Rohini Delhi, preschool Pitampura Delhi, Mother’s Pride Delhi NCR, Mother’s Pride Noida, Mother’s Pride Ghaziabad, Mother’s Pride Gurugram"
        />
      </Helmet>
      <div className="flex flex-col overflow-x-hidden w-full bg-white relative">
        {/* img and animation div for 1st div  */}
        {/* <HeartAnimation /> */}
        <div
          id="heart"
          className="absolute hidden right-[7%] top-[20%] sm:flex items-center h-[25rem] flex-col"
        >
          <div className="h-[85%] border-2 border-[#E72F4E]"></div>
          <img
            alt="spider"
            loading="lazy"
            decoding="async"
            data-nimg="1"
            className="max-w-[64px] max-h-[54px] sm:max-h-[68px] z-30"
            style={{ color: "transparent" }}
            src={homePageImages?.heartLogoImg}
          ></img>
        </div>

        {/* 1st section div */}
        <div>
          <img
            style={{
              width: "100vw",
              height:
                window.innerWidth < 1024
                  ? "100%"
                  : window.innerWidth > 950
                  ? "400px"
                  : "333px",
              marginTop: "-10px",
            }}
            srcSet={homePageImages.homeImg}
            alt=""
            className=" sm:block md:object-cover lg:object-none lg:hidden hidden w-[100vw] "
          />
          <img
            style={{
              width: "100vw",
              marginTop: "-10px",
            }}
            srcSet={homePageImages.homeImg}
            alt=""
            className=" lg:block h-[100%] hidden w-[100vw] "
          />

          <div className="relative overflow-x-hidden min-w-[100vw] max-w-[100vw] sm:hidden block">
            <img
              src={
                window.innerWidth < 450
                  ? homePageImages?.mobileHomeImg
                  : homePageImages?.homeImg
              }
              alt=""
              className="sm:h-[344px] h-[250px]"
            />
          </div>

          {/* 1st section */}
          <div className="text text-justify lg:absolute lg:top-[120px] sm:left-[75px] lg:bg-transparent bg-[#fff3ed] lg:py-0 py-[2rem] sm:py-[4rem] lg:px-0 px-[5%] ">
            <img
              src={homePageImages?.loveBlossomImg}
              alt=""
              className="sm:block hidden sm:mb-0 mb-5 sm:h-[100%]"
            />
            <p
              className="dashboardPara lg:w-[50%] mt-[10px] sm:mt-[20px]"
              style={{ fontSize: "17px" }}
            >
              Mother’s Pride is a labor of love. Love is what founded the
              school. Love is what makes it grow and what keeps it going. Love
              is what we give, and what we get in return. Welcome to the most
              loved preschool! In here, whatever the season, you will always
              find love in full bloom.
            </p>
            <CustomButton
              handleClick={() => navigate("/curriculumOfLove")}
              text={"Explore Now"}
              paddingX="24px"
              paddingY="10px"
              marginTop={window.innerWidth < 750 ? "10px" : "25px"}
            />
          </div>
        </div>

        {/* rest all section */}
        <div>
          <SpreadingLoveSection />

          {/* spreding love three div's box */}
          <SpreadingLoveBoxes />

          <ThirdSection />

          {/* <ThirdSection /> */}

          {/* Our interactive Gallery */}
          <InteractiveGallery />

          <div className="lg:pt-[3%] px-[4%] max-h-[400px] sm:max-h-[750px] bg-white">
            <img
              className="h-full max-h-[250px] sm:min-h-[400px] sm:max-h-[450px] lg:max-h-[750px] lg:min-h-[650px]"
              src={homePageImages?.AdmAwardImg}
              alt="awards-img"
            />
          </div>

          {/* testimonial images */}
          <HomeTestimonialSlider />

          {/* Curriculum of Love container */}
          <ColContainer />

          {/* teaching methodology hover div */}
          <TeachingMethodology />

          <HomeBlogs />

          <Footer marginX={"5%"} />
        </div>
      </div>
    </div>
  );
}
